export enum SideTabs {
  Conditions = 1,
  Settings = 2,
  Comments = 3,
  Preview = 0
}
